var _g, _path, _g2, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMonitoringSubscription = function SvgMonitoringSubscription(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 108,
    viewBox: "0 0 96 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10345_110536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8216 60.4767C47.3961 60.1776 48.0797 60.1753 48.6562 60.4703L75.5213 74.2196C76.973 74.9626 76.973 77.0374 75.5213 77.7804L48.6562 91.5297C48.0797 91.8247 47.3961 91.8224 46.8216 91.5233L20.4081 77.774C18.9727 77.0269 18.9727 74.9731 20.4081 74.226L46.8216 60.4767Z",
    fill: "black",
    fillOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10345_110536",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 12,
    width: 63,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1769 13.1547C47.4145 12.4402 48.9393 12.4402 50.1769 13.1547L77.3538 28.8453C78.5914 29.5598 79.3538 30.8803 79.3538 32.3094V63.6906C79.3538 65.1197 78.5914 66.4402 77.3538 67.1547L50.1769 82.8453C48.9393 83.5598 47.4145 83.5598 46.1769 82.8453L19.0008 67.1547C17.7633 66.4402 17.0009 65.1197 17.0008 63.6907L17.0001 32.3095C17 30.8804 17.7624 29.5598 19.0001 28.8453L46.1769 13.1547Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10345_110536)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.2139 12)",
    fill: "url(#paint0_linear_10345_110536)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.5,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.6469 12.25)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.2139 48)",
    fill: "url(#paint1_linear_10345_110536)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.25,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.2719 48.2165)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10345_110536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.8862 60.6016C56.8862 62.7772 57.6347 64.4315 58.967 65.2007C60.2993 65.9699 62.1062 65.7909 63.9903 64.7031C65.8745 63.6153 67.6814 61.7078 69.0137 59.4002C70.346 57.0927 71.0945 54.574 71.0945 52.3984C71.0945 50.2228 70.346 48.5685 69.0137 47.7993C67.6814 47.0301 65.8745 47.2091 63.9903 48.2969C62.1062 49.3847 60.2993 51.2922 58.967 53.5998C57.6347 55.9073 56.8862 58.426 56.8862 60.6016Z",
    fill: "url(#paint2_linear_10345_110536)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8862 60.6016C56.8862 62.7772 57.6347 64.4315 58.967 65.2007C60.2993 65.9699 62.1062 65.7909 63.9903 64.7031C65.8745 63.6153 67.6814 61.7078 69.0137 59.4002C70.346 57.0927 71.0945 54.574 71.0945 52.3984C71.0945 50.2228 70.346 48.5685 69.0137 47.7993C67.6814 47.0301 65.8745 47.2091 63.9903 48.2969C62.1062 49.3847 60.2993 51.2922 58.967 53.5998C57.6347 55.9073 56.8862 58.426 56.8862 60.6016V60.6016Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.728 58.9609C59.728 60.2663 60.1771 61.2589 60.9765 61.7204C61.7758 62.182 62.86 62.0746 63.9905 61.4219C65.121 60.7692 66.2051 59.6247 67.0045 58.2401C67.8039 56.8556 68.253 55.3444 68.253 54.0391C68.253 52.7337 67.8039 51.7411 67.0045 51.2796C66.2051 50.818 65.121 50.9254 63.9905 51.5781C62.86 52.2308 61.7758 53.3753 60.9765 54.7599C60.1771 56.1444 59.728 57.6556 59.728 58.9609V58.9609Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5693 57.3203C62.5693 57.7554 62.719 58.0863 62.9855 58.2401C63.2519 58.394 63.6133 58.3582 63.9902 58.1406C64.367 57.9231 64.7284 57.5416 64.9948 57.08C65.2613 56.6185 65.411 56.1148 65.411 55.6797C65.411 55.2446 65.2613 54.9137 64.9948 54.7599C64.7284 54.606 64.367 54.6418 63.9902 54.8594C63.6133 55.0769 63.2519 55.4584 62.9855 55.92C62.719 56.3815 62.5693 56.8852 62.5693 57.3203V57.3203Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9907 54.7581L69.0587 47.8259",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9634 57.457C69.0262 57.4208 69.0864 57.4148 69.1308 57.4404C69.1752 57.4661 69.2002 57.5212 69.2002 57.5938",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7266 57.8672C68.7266 57.7947 68.7515 57.7107 68.7959 57.6338C68.8403 57.5569 68.9006 57.4933 68.9634 57.457",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9634 58.0039C68.9006 58.0402 68.8403 58.0461 68.7959 58.0205C68.7515 57.9949 68.7266 57.9397 68.7266 57.8672",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2002 57.5937C69.2002 57.6663 69.1752 57.7502 69.1308 57.8271C69.0864 57.9041 69.0262 57.9676 68.9634 58.0039",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9121 59.3711C60.9749 59.3348 61.0351 59.3289 61.0796 59.3545C61.124 59.3801 61.1489 59.4353 61.1489 59.5078",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6753 59.7813C60.6753 59.7087 60.7002 59.6248 60.7447 59.5479C60.7891 59.4709 60.8493 59.4074 60.9121 59.3711",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9121 59.918C60.8493 59.9542 60.7891 59.9602 60.7447 59.9346C60.7002 59.9089 60.6753 59.8538 60.6753 59.7812",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1489 59.5078C61.1489 59.5803 61.124 59.6643 61.0796 59.7412C61.0351 59.8181 60.9749 59.8817 60.9121 59.918",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7008 48.9805C64.7636 48.9442 64.8238 48.9382 64.8683 48.9639C64.9127 48.9895 64.9376 49.0447 64.9376 49.1172",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.464 49.3906C64.464 49.3181 64.4889 49.2342 64.5333 49.1572C64.5778 49.0803 64.638 49.0167 64.7008 48.9805",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7008 49.5273C64.638 49.5636 64.5778 49.5696 64.5333 49.5439C64.4889 49.5183 64.464 49.4631 64.464 49.3906",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9376 49.1172C64.9376 49.1897 64.9127 49.2737 64.8683 49.3506C64.8238 49.4275 64.7636 49.4911 64.7008 49.5273",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7808 55.9531C58.8436 55.9169 58.9038 55.9109 58.9482 55.9365C58.9926 55.9622 59.0176 56.0173 59.0176 56.0898",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5439 56.3633C58.5439 56.2908 58.5689 56.2068 58.6133 56.1299C58.6577 56.053 58.7179 55.9894 58.7807 55.9531",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7807 56.5C58.7179 56.5363 58.6577 56.5422 58.6133 56.5166C58.5689 56.4909 58.5439 56.4358 58.5439 56.3633",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0176 56.0898C59.0176 56.1624 58.9926 56.2463 58.9482 56.3232C58.9038 56.4002 58.8436 56.4637 58.7808 56.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 17.0381 30)",
    fill: "url(#paint3_linear_10345_110536)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.75,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 17.0961 29.7835)",
    stroke: "white",
    strokeOpacity: 0.4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6769 14.0207C47.6051 13.4848 48.7487 13.4848 49.6769 14.0207L76.8538 29.7113C77.782 30.2472 78.3538 31.2376 78.3538 32.3094V63.6906C78.3538 64.7624 77.782 65.7528 76.8538 66.2887L49.6769 81.9793C48.7487 82.5152 47.6051 82.5152 46.6769 81.9792L19.5008 66.2887C18.5727 65.7528 18.0009 64.7624 18.0008 63.6907L18.0001 32.3094C18 31.2376 18.5718 30.2472 19.5001 29.7113L46.6769 14.0207Z",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10345_110536",
    x: 3.33154,
    y: 44.2507,
    width: 89.2786,
    height: 63.4985,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0862745 0 0 0 0 0.827451 0 0 0 0 0.882353 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10345_110536"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10345_110536",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10345_110536",
    x1: -0.267884,
    y1: 0.267885,
    x2: 35.7321,
    y2: 0.267886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9EFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73DFE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10345_110536",
    x1: -0.535769,
    y1: -0.267884,
    x2: 36.8338,
    y2: -0.136971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78E1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CFDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10345_110536",
    x1: 71.0945,
    y1: 60.597,
    x2: 56.5142,
    y2: 53.1244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10345_110536",
    x1: 17.2767,
    y1: -10.1384,
    x2: 43.4682,
    y2: -1.59252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EE2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CFDE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10345_110536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 17.5,
    fill: "white",
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 56.4126 52.125)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMonitoringSubscription);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "monitoring_subscription.40a8e15ad9756c882b5ac29721c2d9bc.svg";